import ArrowRightIcon from "../../assets/icons/ArrowRightIcon"
import ArrowDownIcon from "../../assets/icons/ArrowDownIcon"
import CloseIcon from "../../assets/icons/CloseIcon"
import { useState, useEffect, Dispatch, SetStateAction, useRef } from "react";
import { Range, getTrackBackground, useThumbOverlap } from 'react-range';
import { getCurrencyValue } from "~/lib/utils"
import { OptionObject } from "~/types";
import { showPriceRangeFilter } from "../../../setup/settings/__product";
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../setup/settings/__nonTransactional";
import { addCalloutOption } from "../../../setup/settings";

type FilterModalProps = {
   currency: string,
   clearFilter: () => void,
   show: boolean,
   close: () => void,
   options: OptionObject[] | undefined,
   price: number[],
   getFilter: () => string,
   editURL: (filter: any) => void,
   setChange: Dispatch<SetStateAction<boolean>>,
   shop: any,

}

export default function FilterModal({ currency, clearFilter, show, close, options, price, getFilter, editURL, setChange, shop }: FilterModalProps) {

   const [optionsSelected, setOptionsSelected] = useState<{ field: string, value: string }[] | undefined>(undefined)
   const [openFields, setOpenFields] = useState<number[]>([])
   const [priceRange, setPriceRange] = useState();
   const priceRangeRef = useRef(priceRange);


   const shopSettings = shop?.settings?.value != null ? JSON.parse(shop.settings.value) : null;
   const calloutDefinitions = shopSettings?.calloutDefinitions?.map(
      (c: any) => ({
         callout: c.callout,
         label: c.label
      })
   ) ?? [];

   const hidefromfiltercategories = shop?.hidefromfiltercategories?.value != null ? JSON.parse(shop?.hidefromfiltercategories?.value ?? []) : [];
   useEffect(() => {

      priceRangeRef.current = priceRange;
   }, [priceRange])


   useEffect(() => {
      if (!optionsSelected) {
         let ops = []
         const filter = getFilter();
         filter.options.forEach(o => {
            o.values.forEach(v => {
               ops.push({ field: o.field, value: v })
            })
         });
         setOptionsSelected(ops);
      }
   }, [])

   useEffect(() => {
      if (!priceRange) {
         const filter = getFilter();
         setPriceRange([filter.price_range.low, filter.price_range.high]);
      }
   }, [priceRange])

   const clickClose = () => {
      close();
   }

   const addField = (field: number) => {
      if (openFields.indexOf(field) == -1)
         setOpenFields(old => [...old, field])
      else
         setOpenFields(old => old.filter(f => f != field))
   }



   const addOption = (field: string, option: any) => {

      let opts = optionsSelected ? [...optionsSelected] : [];
      const dynamicField = addCalloutOption.enabled && field === 'callouts' ? `callouts.${option}` : field;

      const existingOptionIndex = opts.findIndex(o => o.field === dynamicField && o.value === (field === 'callouts' ? 'Yes' : option));
      if (existingOptionIndex !== -1) {
         opts = opts.filter((_, index) => index !== existingOptionIndex);
      } else {
         opts.push({
            field: dynamicField,
            value: field === 'callouts' ? 'Yes' : option
         });
      }

      setOptionsSelected(opts);

      const filter = getFilter();

      const updatedFilter = {
         ...filter,
         options: opts.map(opt => ({
            field: opt.field,
            values: [opt.value]
         })),
         pagination: {
            page: 1,
            limit: filter.pagination.limit
         }
      };

      editURL(updatedFilter);
      setChange(true);
   };



   const changeRange = (value: number[]) => {
      setPriceRange(value);
   }

   const onFinishRange = () => {
      const filter = getFilter();
      const updatedFilter = {
         ...filter,
         price_range: {
            low: priceRangeRef.current[0],
            high: priceRangeRef.current[1]
         }
      }
      editURL(updatedFilter);
      setChange(true);
   }

   const clear = () => {
      setPriceRange(price);
      setOptionsSelected([]);
      clearFilter();
   }
   const parsePriceIcon = (optionName: string) => {
      if (optionName == "topprice") return "££££";
      if (optionName == "midtotopprice") return "£££";
      if (optionName == "midprice") return "££";
      if (optionName == "lowprice") return "£";
      return optionName;
   }
   const getOptions = (options: OptionObject[]) => {
      const items = [];
      options?.map((item, i) => {

         if ((item.field == "hasoptions" && item.options.length > 1) || (item.field == "hasoptions" && optionsSelected?.some(os => os.field === "hasoptions"))) {
            items.push(itemOption(item, i));
         } else if ((item.field == "instock" && item.options.length > 1) || (item.field == "instock" && optionsSelected?.some(os => os.field === "instock"))) {
            items.push(itemOption(item, i));
         } else if ((item.field == "categories.title") && hidefromfiltercategories) {
            const filteredItem = {
               ...item,
               options: item.options.filter(c => !hidefromfiltercategories?.includes(c.key))
            };
            items.push(itemOption(filteredItem, i));
         } else if (item.field !== "instock" && item.field !== "hasoptions") {
            items.push(itemOption(item, i));
         }


      });

      if (addCalloutOption.enabled && calloutDefinitions.length > 0) {
         const calloutItem = {
            field: 'callouts',
            label: addCalloutOption.title,
            options: calloutDefinitions.map((c: any) => ({
               key: c.callout.toLowerCase(), // Esto se enviará al filtro
               label: c.label.toUpperCase(), // Esto se mostrará en la interfaz
               doc_count: 0
            }))
         };
         items.push(itemOptionWithoutCount(calloutItem, 11));
      }
      return (
         <>
            {items.map(o => o)}
         </>
      );
   };

   const getLabelCallout = (callout: any) => {
      const calloutFind = calloutDefinitions.filter((c: any) => c.callout.toLowerCase() === callout.toLowerCase());
      return calloutFind[0].label;
   };

   const itemOptionWithoutCount = (group: OptionObject, i: number) => {
      return (
         <div className="filterSection__filter-group" key={i}>
            <div className="filterSection__category-container">
               <div className={`container-option grey ${openFields.indexOf(i) != -1 && 'open'} ${i === 0 && 'first'}`}>
                  <div className="filterSection__accordion-title">
                     <span onClick={() => addField(i)}>
                        <span className="arrow"><ArrowDownIcon /></span>
                        <p className="option-name">{group.label}</p>
                     </span>
                  </div>

                  <div className="filtersSelect">
                     {optionsSelected?.filter(os => os.field.includes(group.field)).map(os => {
                        return (
                           <>
                              <div className="filtersSelect__item-select" key={os.value}>
                                 <p>{getLabelCallout(os.field.split(".")[1])}</p>
                                 {/* Mostrar el botón Close solo si la opción está marcada y es un callout */}
                                 {group.field.startsWith('callouts') && (
                                    <button
                                       onClick={() => addOption(group.field, os.field.split(".")[1].toLowerCase())}
                                       type="button"
                                       id="buttonFilterOption"
                                       aria-label="Remove filter"
                                    >
                                       <CloseIcon />
                                    </button>
                                 )}
                              </div>
                           </>
                        );
                     })}
                  </div>
                  <div className="filterSection__optionName">
                     <ul>
                        {group.options.map(option => (
                           <li
                              key={option.key}
                              className={`${optionsSelected?.findIndex(os => os.field === group.field && os.value === option.key) !== -1 && 'nameSelected'}`}
                              onClick={() => addOption(group.field, option.key)}
                           >
                              <input
                                 checked={optionsSelected?.findIndex(os => os.field === group.field && os.value === option.key) !== -1}
                                 className="form-check-input appearance-none h-4 w-4 border text-black border-gray-300 rounded-sm bg-neutral-100 !focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                 type="checkbox"
                                 value=""
                                 id="checkSelection"
                              />
                              {option.label}
                           </li>
                        ))}
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      );
   };


   const itemOption = (group: OptionObject, i: number) => {
      return (
         <div className="filterSection__filter-group">
            <div className="filterSection__category-container">
               <div className={`container-option grey ${openFields.indexOf(i) != -1 && 'open'} ${i === 0 && 'first'}`}>
                  <div className="filterSection__accordion-title">
                     <span onClick={() => addField(i)}>
                        <span className="arrow"><ArrowDownIcon /></span>
                        <p className="option-name">{group.label}</p>
                     </span>
                  </div>

                  <div className="filtersSelect">
                     {optionsSelected?.filter(os => os.field === group.field).map(os =>
                        <div className="filtersSelect__item-select">
                           <p>{parsePriceIcon(os.value)}</p>
                           <button onClick={() => addOption(group.field, os.value)} type="button" id="buttonFilterOption" aria-label="Quitar el filtro BEAUTIFUL HOME COLLECTIONS">
                              <CloseIcon />
                           </button>
                        </div>
                     )}
                  </div>
                  <div className="filterSection__optionName">
                     <ul>
                        {group.options.map(option =>
                           <li className={`${optionsSelected?.findIndex(os => os.field == group.field && os.value == option.key) != -1 && 'nameSelected'}`} onClick={() => addOption(group.field, option.key)}>
                              <input checked={optionsSelected?.findIndex(os => os.field == group.field && os.value == option.key) != -1}
                                 className="form-check-input appearance-none h-4 w-4 border text-black border-gray-300 rounded-sm bg-neutral-100 !focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                 type="checkbox" value="" id="checkSelection" />
                              {parsePriceIcon(option.key)} <span>({option.doc_count})</span>
                           </li>
                        )}
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      )
   }

   const mouseRef = useRef(false)

   const handleMouseDown = (event) => {
      mouseRef.current = true;
   }

   const handleMouseUp = (event) => {
      if (mouseRef.current) {
         onFinishRange();
      }
      mouseRef.current = false;
   }


   const handleTouchmoveStart = (event) => {
      mouseRef.current = true;
   }
   const handleTouchmove = (event) => {
      if (mouseRef.current) {
         onFinishRange();
      }
      mouseRef.current = false;
   }

   useEffect(() => {
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchmove);
   }, [])

   const rangeRef: any = useRef<Range>();

   function ThumbLabel({
      rangeRef,
      values,
      index
   }: {
      rangeRef: Range | null;
      values: number[];
      index: number;
   }) {
      const [labelValue, labelStyle] = useThumbOverlap(
         rangeRef,
         values,
         index,
         1,
         ' - ',
         (value) => getCurrencyValue(currency, (+value).toFixed(1))
      );
      return (
         <div
            data-label={index}
            style={{
               display: 'block',
               position: 'absolute',
               whiteSpace: 'nowrap',
               bottom: '-30px',
               color: 'black',
               fontSize: '12px',
               padding: '1px',
               borderRadius: '4px',
               lineHeight: '5px',
               textAlign: 'center',

               ...(labelStyle as React.CSSProperties)
            }}
         >
            {labelValue}
         </div>
      );
   }

   return (
      <div className={`collapseMenu ${show && 'openCollapse'}`}>
         <div onClick={close}></div>
         <div className={`customize-modal ${show && 'show'}`}>
            <div className="content">
               <span className="back" onClick={clickClose}><ArrowRightIcon /></span>
            </div>
            <div className="filterSection">
               <div className="filterSection__container">
                  <div className="filterSection__top-area">
                     <div className="ProductTop__category-name">
                        <p>Filters</p>
                     </div>
                     <div className="ProductList__clear-button">
                        <button onClick={clear} type="button">Clear All </button>
                     </div>
                  </div>
                  {showPriceRangeFilter && (!isNonTransactional || showPriceshowPriceTransactional) &&
                     <div id="range-div" className="mt-6" onMouseDown={handleMouseDown} onTouchEndCapture={handleTouchmoveStart}>
                        <p className="option-name">Price</p>

                        <div className="rangePrices"
                           style={{
                              display: 'flex',
                              justifyContent: 'center',
                              flexWrap: 'wrap'
                           }}
                        >
                           {price != undefined && priceRange != undefined && price[1] != 0 &&
                              <Range
                                 ref={rangeRef}
                                 values={priceRange}
                                 min={price[0]}
                                 max={price[1]}
                                 onChange={changeRange}
                                 renderTrack={({ props, children }) => (
                                    <div
                                       onMouseDown={props.onMouseDown}
                                       onTouchStart={props.onTouchStart}
                                       style={{
                                          ...props.style,
                                          height: '30px',
                                          display: 'flex',
                                          width: '100%'
                                       }}
                                    >
                                       <div
                                          ref={props.ref}
                                          style={{
                                             height: '2px',
                                             width: '100%',
                                             borderRadius: '4px',
                                             background: getTrackBackground({
                                                values: priceRange ?? [0, 0],
                                                colors: ['#CCC', 'black', '#CCC'],
                                                min: price[0],
                                                max: price[1],
                                                rtl: false
                                             }),
                                             alignSelf: 'center'
                                          }}
                                       >
                                          {children}
                                       </div>
                                    </div>
                                 )}
                                 renderThumb={({ index, props, isDragged }) => (
                                    <div
                                       {...props}
                                       style={{
                                          ...props.style,
                                          height: '20px',
                                          width: '20px',
                                          borderRadius: '10px',
                                          backgroundColor: '#FFF',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          boxShadow: '0px 2px 6px #AAA',
                                          marginLeft: '20px',
                                          marginRight: '20px'
                                       }}
                                    >
                                       <ThumbLabel rangeRef={rangeRef.current} values={priceRange} index={index} />
                                       <div
                                          style={{
                                             height: '10px',
                                             width: '10px',
                                             borderRadius: '10px',
                                             backgroundColor: isDragged ? 'black' : '#CCC'
                                          }}
                                       />
                                    </div>
                                 )}
                              />
                           }

                        </div>

                     </div>}
                  <div className="filterSection__filter-container">
                     {options != undefined && getOptions(options)}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}